import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFIcon,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerbg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          image={`url(${headerbg}) bottom / cover no-repeat`}
          style={{
            backdropFilter: 'blur(10px)',
            webkitBackdropFilter: 'blur(10px)',
          }}
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          pv="5px"
        >
          <CFView column center>
            <CFImage h="40px" mb="5px" src={logo} alt="Masita Korean Cuisine" />
            <CFView
              center
              br="25px"
              bc="white"
              bw="2.5px"
              pv="5px"
              ph="15px"
              pointer
              hover
              zIndex={99}
              mv="5px"
              ml="15px"
            >
              <CFView h4 color="white" bold mb="2px">
                Vancouver Granville St
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          h="55px"
          image={`url(${headerbg}) bottom / cover no-repeat`}
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          zIndex={98}
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView row center>
              <CFImage
                h="43px"
                ml="55px"
                src={logo}
                alt="Sushi Umi Japanese Restaurant Logo"
                zIndex={98}
              />
              <CFView
                center
                br="25px"
                bc="white"
                bw="2.5px"
                pv="5px"
                ph="15px"
                pointer
                hover
                zIndex={99}
                mt="5px"
                ml="15px"
              >
                <CFView h3 color="white" bold mb="2px">
                  Vancouver Granville St
                </CFView>
              </CFView>
            </CFView>
            {/* <CFView hover mt="10px">
              <CFLink href={orderingUrl}>
                <CFImage
                  h="70px"
                  src={viewMenu}
                  alt="Sushi Umi Japanese Restaurant View Menu Button"
                />
              </CFLink>
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
